import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, IPregameApiListResponse } from '@/types';

export const pregame = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IPregameApiListResponse>> => {
    return axios.get('/api/event/pregame', { ...config, params });
};
